import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { readSupabasePublishable, readSupabaseUrl } from 'shared/lib/env';

const supabaseUrl = readSupabaseUrl();
/** Supabase dashboard: Project Settings → API → publishable key */
const supabasePublishableKey = readSupabasePublishable();

export const isSupabaseConfigured =
  Boolean(supabaseUrl) && Boolean(supabasePublishableKey);

let supabase: SupabaseClient | null = null;

if (isSupabaseConfigured) {
  supabase = createClient(supabaseUrl, supabasePublishableKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

export function getSupabase(): SupabaseClient {
  if (!supabase) {
    throw new Error(
      'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY.'
    );
  }
  return supabase;
}

export { supabase };
